// src/components/ui/article/ArticleStats.tsx
'use client';

import type { ReactNode } from 'react';
import clsx from 'clsx';
import { IconView, IconChatOutline, IconCoinOutline, IconShareOutline2 } from '@/components/icons';

/** 共用的千位縮寫：13500 -> 13.5K */
export function formatCount(n: number | undefined): string {
  if (typeof n !== 'number' || Number.isNaN(n)) return '0';
  if (n < 1000) return String(n);
  if (n < 10000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  if (n < 1_000_000) return Math.round(n / 1000) + 'K';
  return (n / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
}

type ArticleStatItemProps = {
  icon: ReactNode;
  value: number | undefined;
  /** 要不要顯示後綴文字（例如「次觀看」「則回覆」），Detail 頁就可以不傳 */
  suffix?: string;
  className?: string;
};

export function ArticleStatItem({ icon, value, suffix, className }: ArticleStatItemProps) {
  return (
    <span className={clsx('d-inline-flex align-items-center', className)}>
      {icon}
      <span className="ms-1">{formatCount(value)}</span>
      {suffix && <span className="ms-1">{suffix}</span>}
    </span>
  );
}

type BasicStatProps = {
  value: number | undefined;
  /** 列表要傳文字，Detail 不傳就不顯示文字 */
  suffix?: string;
  className?: string;
};

export function ViewStat({ value, suffix, className }: BasicStatProps) {
  return (
    <ArticleStatItem
      icon={<IconView width={20} />}
      value={value}
      suffix={suffix}
      className={className}
    />
  );
}

export function ReplyStat({ value, suffix, className }: BasicStatProps) {
  return (
    <ArticleStatItem
      icon={<IconChatOutline width={20} />}
      value={value}
      suffix={suffix}
      className={className}
    />
  );
}

export function CoinStat({ value, suffix, className }: BasicStatProps) {
  return (
    <ArticleStatItem
      icon={<IconCoinOutline width={22} />}
      value={value}
      suffix={suffix}
      className={className}
    />
  );
}

export function ShareStat({ value, suffix, className }: BasicStatProps) {
  return (
    <ArticleStatItem
      icon={<IconShareOutline2 width={22} />}
      value={value}
      suffix={suffix}
      className={className}
    />
  );
}
